import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded' //  后端限制获取参数是通过form表单提交
  // }
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    //  do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)


// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if the custom code is not 0, it is judged as an error.
    if (res.code !== '0') {
      return res
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
